/**
 * 두 문자열을 비교하여 다른 부분을 강조 표시
 * @param {string} str1 - 첫 번째 문자열
 * @param {string} str2 - 두 번째 문자열
 * @returns {Array} - [{ text, isDifferent }] 형태의 배열
 */
export function highlightDifferences(str1, str2) {
  if (!str1 && !str2) return [];
  if (!str1) return [{ text: str2 || '', isDifferent: true }];
  if (!str2) return [{ text: str1 || '', isDifferent: true }];

  const s1 = String(str1);
  const s2 = String(str2);

  // 두 문자열이 완전히 같으면 차이 없음
  if (s1 === s2) {
    return [{ text: s1, isDifferent: false }];
  }

  // 문자 단위로 비교
  const maxLen = Math.max(s1.length, s2.length);
  const result = [];
  let currentSegment = { text: '', isDifferent: false };

  for (let i = 0; i < maxLen; i++) {
    const char1 = s1[i] || '';
    const char2 = s2[i] || '';
    const isDiff = char1 !== char2;

    // 현재 문자의 차이 여부가 이전 세그먼트와 같으면 계속 추가
    if (currentSegment.isDifferent === isDiff) {
      currentSegment.text += char1;
    } else {
      // 다르면 이전 세그먼트를 저장하고 새 세그먼트 시작
      if (currentSegment.text) {
        result.push(currentSegment);
      }
      currentSegment = { text: char1, isDifferent: isDiff };
    }
  }

  // 마지막 세그먼트 추가
  if (currentSegment.text) {
    result.push(currentSegment);
  }

  return result;
}

/**
 * 강조된 텍스트를 React 엘리먼트로 렌더링
 * @param {string} str1 - 첫 번째 문자열
 * @param {string} str2 - 두 번째 문자열
 * @returns {JSX.Element}
 */
export function renderHighlightedText(str1, str2) {
  const segments = highlightDifferences(str1, str2);

  return (
    <>
      {segments.map((segment, idx) => (
        <span
          key={idx}
          className={segment.isDifferent ? 'text-[#C5221F] font-medium bg-[#FCE8E6] px-0.5 rounded' : ''}
        >
          {segment.text}
        </span>
      ))}
    </>
  );
}

